import React from "react";
import { useDispatch, useViewState } from "./hooks/useState";
import SearchForm from "./SearchForm";

const SearchResult = () => {
  const { filterLocations } = useDispatch();
  const { locations, translations } = useViewState();

  const [activeFilter, setFilter] = React.useState(3);

  React.useEffect(() => filterLocations(activeFilter), [activeFilter]);

  const mobileFilters = React.useMemo(
    () => [
      { id: 0, label: "A - H" },
      { id: 1, label: "I - R" },
      { id: 2, label: "S - Ö" },
      { id: 3, label: "Alla" },
    ],
    []
  );
  return React.useMemo(() => (
    <div className="o-findOffice__results">
      <SearchForm />
      <h2>
        {translations.allPlaces} ({locations.length})
      </h2>
      <form className="o-findOffice__filterResults">
        {mobileFilters.map((filter) => (
          <div key={filter.id} className="m-field -asTab">
            <input
              name="filter-results"
              type="radio"
              id={filter.id}
              value={filter.id}
              checked={filter.id === activeFilter}
              onChange={({ target }) => setFilter(parseInt(target.value, 10))}
              aria-controls="find-office-results"
            />
            <label className="m-field__label" htmlFor={filter.id}>
              {filter.label}
            </label>
          </div>
        ))}
      </form>
      <ul className="-plain" id="find-office-results">
        {locations.map(
          (location) => (
            <li key={location.name}>
              <a href={location.link} className="o-findOffice__result">
                <h3>{location.name}</h3>
                <address>
                  {location.address}
                  <br />
                  {location.zip} {location.town}
                </address>
              </a>
            </li>
          ),
          [locations]
        )}
      </ul>
    </div>
  ));
};

export default SearchResult;
